import React from 'react'
import { toast } from 'react-toastify'

export const notificationSuccess = (text) => {
  return toast.success(text, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const notificationSuccessCustomTime = (text, time) => {
  return toast.success(text, {
    position: 'top-right',
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const notificationDanger = (text) => {
  return toast.error(text, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const notificationDangerCustomTime = (text, time) => {
  return toast.error(text, {
    position: 'top-right',
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const notificationDangerMultipleRows = (array) => {
  return toast.error(
    <div>
      {array &&
        array.map((i) => {
          return <div key={i}>{i}</div>
        })}
    </div>,
    { position: toast.POSITION.UPPER_RIGHT }
  )
}

export const notificationWarning = (text) => {
  return toast.warn(text, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const notificationInfo = (text, time) => {
  return toast.info(text, {
    position: 'top-right',
    autoClose: time ? time : 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const notificationCRM = (text) => {
  return toast(text, {
    className: 'gold-color-background',
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
  })
}

export const realTimeNotification = (data, options = {}) => {
  const { title, text } = data
  const { hideTitle } = options
  return toast.info(
    <div className='notifications'>
      {!hideTitle && (
        <div className='notifications__title' style={{ fontSize: '15px' }}>
          {title}
        </div>
      )}
      <div className='notifications__text' style={{ fontSize: '13px', textAlign: 'start' }}>
        {text}
      </div>
    </div>,
    {
      position: 'bottom-right',
      autoClose: 300000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      // onClose:(c) => console.log(text)
    }
  )
}
